<template>
  <div class="yb-view-content yb-view">
    <div class="yb-view-left pt-8 pl-4 pr-8">
      <yb-icon icon="info" class="yb-button-icon h-12 w-12 text-yb-bluebird dark:text-yb-blue-light" />
    </div>
    <div class="yb-view-content flex flex-col space-y-6">
      <div class="font-medium text-lg">
        The text could not be copied to the clipboard.
      </div>
      <div class="text-lg">
        <a class="yb-link" @click="copy" ref="copy">Please click here</a> to grant access to the clipboard.
      </div>
    </div>
  </div>

</template>

<script>
import { copyToClipboard } from '@shared/utils/misc/clipboard'

export default {
  name: 'YbClipboard',
  props: {
    text: String,
    label: {
      type: String,
      required: false,
    },
    dialogController: Object
  },
  methods: {
    async copy() {
      try {
        copyToClipboard(this.$refs.copy, this.text, this.label)
        await timeout(2 * 1000)
        this.dialogController?.close()
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>
